import axios from './http';
// import CONFIG from '@/config/index.js'


export const getVideoList = params => axios.get('/api/abilityimprovement/getlist', params);
export const getVideoDetail = params => axios.get('/api/abilityimprovement/getinfo', params);
export const getpchome = params => axios.get('/api/site/getpchome', params);
export const getlistbyschool = params => axios.get('/api/position/getlistbyschool', params);
export const getQrCodeData = params => axios.get('/api/qrcodeparameter/create', params);
export const recordData = params => axios.get('/api/abilityimprovement/watched', params);
export const clearLoginData = params => axios.get('/api/user/loginout', params)
export const getSchoolData = params => axios.get('/school/site/home', params)




export const getPostDetail = params => axios.get('/api/position/getdetail', params)
export const getCompanyDetail = params => axios.get('/api/company/getdetail', params)
export const addCollect = params => axios.post('/api/collect/add', params)
export const cancelCollect = params => axios.post('/api/collect/cancel', params)
export const getpositionlist = params => axios.post('/api/company/getpositionlist', params)
export const getresumelist = params => axios.post('/api/resume/getresumelist', params)
export const deliverResume = params => axios.post('/api/resume/deliver', params)
export const getdeliverstatus = params => axios.post('/api/resume/getdeliverstatus', params)





export const getdeliverList = params => axios.get('/api/deliver/getList', params)
export const getnotreadinginfo = params => axios.get('/api/deliver/getnotreadinginfo', params)
export const myCollectList = params => axios.get('/api/collect/getpositionlist', params)
export const getcompanylist = params => axios.get('/api/collect/getcompanylist', params)

// 获取首页配置
export const gethomeConfig = params => axios.post('/api/site/gethomeconfig', params)
// 获取所有在招职位列表
export const getlistbySelect = params => axios.post('/api/position/getlistbyselect', params)

// 根据场景id获取场景相关配置信息
export const getScenceInfo = params => axios.post('/api/zone/get', params)

// 3.1 获取公司列表
export const getlistCompany = params => axios.get('/api/company/getlist', params)

// 内容素材 列表获取
export const getcontentList = params => axios.get('/api/mediamaterial/getlist', params)

// 内容素材视频详情获取
export const getMediamaterialVideo = params => axios.get('/api/mediamaterial/getinfo', params)
// 获取校下招聘会信息
export const jobfairzoneGetinfo = params => axios.get('/api/schooljobfairzone/getinfo', params)
// 获取校下招聘会下企业列表
export const jobfairzoneGetcompanylist = params => axios.get('/api/schooljobfairzone/getcompanylist', params)
// 获取校下招聘会展位标签
export const getfairlabel = params => axios.get('/api/schooljobfairzone/getfairlabel', params)

// 获取域名下院系配置信息
export const getschoollabel = params => axios.get('/api/schoolcollege/gethomeconfig', params)
// 站点下属院系获取
export const getsitecollege = params => axios.get('/api/site/getsitecollege', params)
// 站点下属专业获取
export const getsitemajors = params => axios.get('/api/site/getsitemajors', params)
// 院系下职位列表获取
export const getlistbycollege = params => axios.get('/api/position/getlistbycollege', params)
// 院系下企业列表获取
export const getlistbycollegeCompany = params => axios.get('/api/company/getlistbycollege', params)

// 招聘会列表获取
export const getjobfairlist = params => axios.get('/api/schoolcollege/jobfairlist', params)

// 校验登录状态
export const checkLogin = params => axios.post('/api/user/checkstulogin', params)


//获取当前域名站点信息
export const getsiteInfo = params => axios.get('/api/site/getsiteinfo', params)
// 获取企业站点信息（未填写企业信息使用）
export const getcominfo = params => axios.post('/company/site/getinfo', params)

// 获取企业站点信息（未填写企业信息使用）
export const getschoolqrcode = params => axios.post('/school/site/getschoolqrcode', params)
// 渠道端登录
export const channelLogin = params => axios.post('/channel/user/login', params)
export const getcomset = params => axios.post('/api/site/getconfig', params)

// 获取职位推荐列表
export const getrecommend = params => axios.get('/api/position/getrecommend', params)

//用户是否关注公众账号
export const checkAccount = params => axios.get('/api/user/checkaccountfollow', params)

// 资源位配置的首页信息获取
export const getHomeResource = () => axios.get('/api/site/gethomeresource')

// 企业资源配置列表获取
export const getHomeCompanyResource = () => axios.get('/api/company/gethomeresource')

//  职位资源配置列表获取
export const getHomePositionResource = () => axios.get('/api/position/gethomeresource')




// WEBPACK FOOTER //
// ./src/api/indexPage.js